import { PrimaryText } from '@components/Common/PrimaryText/PrimaryText'
import React from 'react'
import { StyleSheet, View } from 'react-native'
import { COLORS } from '@utils/colors'
import { RiAlertFill } from 'react-icons/ri'
import { MenuItem, Select } from '@mui/material'
import { LuChevronDown } from 'react-icons/lu'
import { CustomPickerProps } from '@Interfaces/Component/CustomPickerInterface'

export const CustomPicker: React.FC<CustomPickerProps> = (props) => {
  const {
    title,
    value,
    onChange,
    errorMessage,
    mandatory,
    options,
    placeholder,
    label: customLabel = null,
    backgroundColor = COLORS.primary.offWhite,
  } = props

  const style = styles()

  return (
    <View style={[style.container, props?.style && { ...props.style }]}>
      {!!title && (
        <PrimaryText fontSize={14} fontWeight={700} style={style.inputTitle}>
          {title}
          {mandatory && (
            <PrimaryText fontSize={14} fontWeight={700} style={{ color: COLORS.primary.error }}>
              {'*'}
            </PrimaryText>
          )}
        </PrimaryText>
      )}

      <Select
        displayEmpty
        value={value ?? ''}
        placeholder={'Select...'}
        onChange={(e) => onChange?.(e.target.value)}
        fullWidth
        sx={{
          borderRadius: 15,
          borderWidth: 0.5,
          height: 30,
          backgroundColor,
          borderColor: COLORS.primary.lightGray,
          paddingRight: 5,
          '.MuiSelect-select': {
            paddingTop: 4,
            paddingBottom: 4,
            height: 26,
          },
        }}
        MenuProps={{
          PaperProps: {
            sx: {
              maxHeight: 372,
            },
          },
        }}
        IconComponent={() => <LuChevronDown size={24} style={{ minWidth: 24 }} />}
        renderValue={(val) => {
          const label = options?.find((x) => x.value === val)?.label ?? (placeholder || 'Select...')

          return (
            <PrimaryText
              fontSize={14}
              fontWeight={400}
              style={{
                fontSize: 14,
                color: COLORS.primary.darkGray,
                fontWeight: 400,
                fontFamily: 'Montserrat',
              }}
              numberOfLines={1}
            >
              {customLabel ? customLabel : label}
            </PrimaryText>
          )
        }}
      >
        {options &&
          options.map((item) => {
            return (
              <MenuItem
                value={item?.value}
                key={item?.value}
                sx={{
                  minHeight: 26,
                  '&.Mui-selected': {
                    backgroundColor: COLORS.primary.neutral_100,
                  },
                }}
              >
                <PrimaryText fontSize={12} fontWeight={400}>
                  {item?.label}
                </PrimaryText>
              </MenuItem>
            )
          })}
      </Select>

      {errorMessage && (
        <View style={style.errorContainer}>
          <RiAlertFill
            width={16}
            height={16}
            fill={COLORS.primary.error}
            stroke={COLORS.primary.white}
          />
          <PrimaryText fontSize={14} fontWeight={400} style={style.errorMessage}>
            {errorMessage}
          </PrimaryText>
        </View>
      )}
    </View>
  )
}

const styles = () =>
  StyleSheet.create({
    container: {
      flexGrow: 1,
      flexDirection: 'column',
    },
    inputTitle: {
      paddingLeft: 10,
      marginBottom: 5,
      color: COLORS.primary.darkGray,
    },
    errorContainer: {
      backgroundColor: COLORS.background.lightRed,
      justifyContent: 'flex-start',
      alignItems: 'center',
      paddingHorizontal: 16,
      paddingVertical: 8,
      borderRadius: 8,
      flexDirection: 'row',
    },
    errorMessage: {
      color: COLORS.primary.error,
      paddingLeft: 8,
    },
  })
